import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { each } from 'Utils/lodashUtils';
import {
  queueMetaData,
  getAnalystHeaderCountDataColumns,
  getRegionHeaderCountDataColumns,
  addIconsToGDTableHeadersList,
  analystDrawerMetaData
} from '../QueueManagementLanding/configStructure';
import GDTable from 'Components/GDTable';
import EmptyState from 'Components/EmptyState/EmptyState';
import { getTranslations } from './configStructure';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import { connect } from 'react-redux';
import { fetchDataColumnsCustomQueue } from 'Actions/dataColumnsAction';
import {
  dangerNotificationBanner,
  closeNotificationBanner,
} from 'Actions/notificationAction';
import { setCords, resetCords } from 'Actions/floatingPanelAction';
import FloatingPanel from 'Components/FloatingPanel/FloatingPanel';
import {
  formatAvailableFilters,
  formatActiveFilters,
  splitMergedElementIdsFilters,
  mapActiveFilters,
  convertJsonObjectToArray,
  splitMergedElementIdsFilterValues,
  mergeSavedElementIdsForRangeElements,
  mapSavedFilters,
  removeFilterActionSavedFilter,
  splitMergedElementIdsFilterValuesSaveFilter,
} from 'Utils/dynamicListSelectorUtil';
import { exportUserQueueData } from 'Apis/exportApi';
import { openNotificationToast } from 'Utils/notificationMessageUtils.jsx';
import AnalystSearch from 'Components/AnalystSearch';
import { loadState } from '../../store/browserStorage';
import { getUrlSearchParamValue } from 'Utils/urlUtils';
import {
  getFilterValuesBasedOnElementId,
  getFilterValuesBasedOnElementIdWithAcquirer,
  urlRelativeMapping
} from 'Apis/caseDataAPI.js';
import classnames from 'classnames';
import FilterPane from 'Components/FilterPane';
import {
  getDynamicFitlersAccCustomQueue,
  postActiveDynamicFilters,
  postActiveFilterValues,
  getSavedFiltersBasedOnSearchTypeId,
  deleteSavedFilter,
} from 'Apis/searchFilterApi';
import ResponseBanner from 'Components/cards/ResponseBanner/ResponseBanner.jsx';
import GDActiveFiltersDropdown from 'Components/GDActiveFiltersDropdown/GDActiveFiltersDropdown';
import LinkInlineButton from 'Components/Button/LinkInlineButton';
import GDNewFilterDropdown from 'Components/GDNewFilterDropdown';
import GDSavedFiltersDropdown from 'Components/GDSavedFiltersDropdown';
import OptionBoxPopup from 'Components/OptionBoxPopup';
import StarIcon from 'Components/icons/StarIcon';
import { postActiveFilters } from 'Apis/caseDataAPI';
import { sort_by } from 'Utils/functionalUtils.js';
import { gotoNewTabCaseLandingPage } from 'Utils/newTabUtils.jsx';
import { downloadFile } from 'Utils/exportFunctionality.js';
import * as KeyConstants from 'Utils/constants/keyConstants.js';
import './OpenQueueLandingPage.scss';
import DropDownList from 'Components/DropDownList/DropDownList';
import {
  getAssignedCasesHeaderData,
  getQueueSummary,
  getDataForDynamicQueueLanding,
  getMyQueues,
  getGroupAnalystDetails,
  unAssignCase,
  assignCase,
  bulkAssignment,
  assignCasesToGroup,
  postBookMarkCase,
  undoBookMarkCase,
  getBookMarkedCases,
  getAllQueueList,
  getBaseQueueGroupList,
  getSubQueueGroupList,
  getQueueLabels,
  urlMapping,
  fetchFilterValuesBasedOnElementId,
} from 'Apis/queueManagerApi.js';
import { getAcquirerAccessList } from 'Utils/permissionsUtils';
import ImagePortal from '../ImagePortal/ImagePortal';
import { COLORS } from "Constants/BIDashboardConstants"

const DEFAULT_DRAG_OVER_TEXT = 'Drag over to the analyst to assign cases.';
const __BOOKMARK_QUEUE__ = 70;
const __NON_UNASSIGNABLE_CASES_QUEUES__ = [66, 67];
const __BASEQUEUE_SEARCH_TYPE__ = "cq_base_queue";
export class BaseQueueLanding extends Component {
  constructor(props) {
    super(props);
    this.userIdByLogin = getUrlSearchParamValue(this.props.location.search, 'userid');
    this.state = {
      clearSearchTermValue: false,
      isVisible: false,
      filters: [],
      isLoading: true,
      scrollPos: 0,
      totalPages: 0,
      caseData: [],
      totalRecords: 0,
      recordsShown: 0,
      currentPage: 0,
      isNextPage: false,
      caseDataErr: false,
      exporting: false,
      filterExportIsVisible: false,
      appliedFilters: [],
      sort: [],
      dateFormat: queueMetaData().dateFormat,
      filterText: '',
      savedFilterTranslations: {},
      isRequiredFilter: false,
      isTableVisible: false,
      isLoadingComplete: true,
      isRefreshed: false,
      dataColumns: [],
      timeBoxData: {
        date: new Date(),
        isRefreshRequired: true,
        text: 'Last refreshed',
      },
      headerCountData: {},
      queueMetaData: queueMetaData(),
      selectedRows: [],
      bookMarkedRows: [],
      currentGroupAnalysts: [],
      dragOvertText: DEFAULT_DRAG_OVER_TEXT,
      casesToHide: [],
      totalBulkCases: 0,
      resetCaseCount: false,
      totalRecordsUpdated: -1,
      scrollPos: 0,
      activeFiltersValues: [],
      activeFilters: [],
      availableFilters: [],
      isBookMarked: false,
      filterTypeId: 0,
      exportFilterTypeId: 0,
      dropdownToggled: {
        active: false,
        inactive: false,
      },
      finalFilterElements: [],
      apiMultiSelectCount: 0,
      isRequiredFilter: false,
      saveFilterToggled: false,
      filterName: '',
      noSavedFilters: false,
      savedFilters: [],
      currentSearchTerm: '',
      savdActiveFilters: [],
      tempSavedFilters: [],
      queueSearchView: {
        "filterTypeId": 0,
        "searchFilterInputElements": []
      },
      saveFilterFail: false,
      setSize: false,
      sortArr: [],
      isCurrentlySavedFilters: false,
      dynamicFilterFlag: false,
      formattedFilters: [],
      userIdState: this.userIdByLogin,
      statusErrorCode: 0,
      dropDownBaseQueues: [],
      dropDownSubQueues: [{ focus: true }],
      selectedBaseQueueItem: {},
      selectedSubQueueItem: { text: "Select Queue" },
      acquirerAccessList: []
    };
    this.attachBindings();
    this.attachListeners();
  }

  attachListeners() {
    // TODO: Add any event lister required.
  }

  attachBindings() {
    this.gotoCaseLandingPage = this.gotoCaseLandingPage.bind(this);
    this.rowActionClick = this.rowActionClick.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.saveCurrentlyVisibleColumns = this.saveCurrentlyVisibleColumns.bind(this);
    this.refreshTimeFeed = this.refreshTimeFeed.bind(this);
    this.fetchHeaderCountData = this.fetchHeaderCountData.bind(this);
    this.getQueueNameByRegionAndId = this.getQueueNameByRegionAndId.bind(this);
    this.getUsersQueueName = this.getUsersQueueName.bind(this);
    this.getRegionCodeHeaderData = this.getRegionCodeHeaderData.bind(this);
    this.getAssignedCasesHeaderData = this.getAssignedCasesHeaderData.bind(this);
    this.onCheckboxClick = this.onCheckboxClick.bind(this);
    this.unAssignCase = this.unAssignCase.bind(this);
    this.assignCase = this.assignCase.bind(this);
    this.fetchGroupAnalystsDetails = this.fetchGroupAnalystsDetails.bind(this);
    this.bulkAssignClick = this.bulkAssignClick.bind(this);
    this.onAssignClick = this.onAssignClick.bind(this);
    this.bulkAssignment = this.bulkAssignment.bind(this);
    this.assignCasesToGroup = this.assignCasesToGroup.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.setTotalBulkCases = this.setTotalBulkCases.bind(this);
    this.closeFilterPane = this.closeFilterPane.bind(this);
    this.toggleFilterPane = this.toggleFilterPane.bind(this);
    this.resetScrollPos = this.resetScrollPos.bind(this);
    this.updateColumnsInfo = this.updateColumnsInfo.bind(this);
    this.fetchDynamicFilterAccToQueueId = this.fetchDynamicFilterAccToQueueId.bind(this);
    this.saveActiveDynamicFilters = this.saveActiveDynamicFilters.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.onBookMarked = this.onBookMarked.bind(this);
    this.closeBanner = this.closeBanner.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.deactivateFilter = this.deactivateFilter.bind(this);
    this.clearAllFilters = this.clearAllFilters.bind(this);
    this.toggleSavedFilter = this.toggleSavedFilter.bind(this);
    this.saveFilterName = this.saveFilterName.bind(this);
    this.onChange = this.onChange.bind(this);
    this.updateSearchField = this.updateSearchField.bind(this);
    this.removeSavedFilter = this.removeSavedFilter.bind(this);
    this.setSavedFilterAsActive = this.setSavedFilterAsActive.bind(this);
    this.applySavedFilterSet = this.applySavedFilterSet.bind(this);
    this.closeSaveFilterFailBanner = this.closeSaveFilterFailBanner.bind(this);
    this.getQueueList = this.getQueueList.bind(this);
    this.selectQueue = this.selectQueue.bind(this);
    this.checkSize = this.checkSize.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.getFormattedResponse = this.getFormattedResponse.bind(this);
    this.getMultiSelectFilterValues = this.getMultiSelectFilterValues.bind(this);
    this.updateIsIndeterminate = this.updateIsIndeterminate.bind(this);
    this.getFormattedResponseCorpRegion = this.getFormattedResponseCorpRegion.bind(this);
    this.groupByRegion = this.groupByRegion.bind(this);
    this.clearGroupSearchValue = this.clearGroupSearchValue.bind(this);
  }

  componentWillMount() {
    scroll(0, 0);
    document.addEventListener('keydown', this.onKeyPres);
    document.addEventListener('keypress', this.onKeyPress);
    const region = getUrlSearchParamValue(this.props.location.search, 'region');
    const queueId = getUrlSearchParamValue(this.props.location.search, 'queueid');
    const userId = getUrlSearchParamValue(this.props.location.search, 'userid');
    const acquirerAccessCode = this.state.acquirerAccessList;
    const customQueueId = getUrlSearchParamValue(this.props.location.search, 'customQueueId');

    const auth = loadState('auth');
    const userPermission = auth.user.parsedPermissions;
    this.setState({
      userPermission,
    });
    if (userId) {
      this.setState({
        userIdState: userId,
      })
      this.getUsersQueueName(userId);
      // Unassign should be only for the user queue
    } else {
      this.getQueueNameByRegionAndId(region, queueId, acquirerAccessCode);
    }
    let queueMetaDataClone = queueMetaData(userPermission, userId, true);
    this.setState({
      queueMetaData: queueMetaDataClone,
    });
    this.fetchHeaderCountData(this.props.location.search);

    // Fetch columns as per the regional queue and user queue.
    this.setState({
      selectedBaseQueueItem: { id: customQueueId }
    }, () => {
      if (userId) {
        this.props.fetchDataColumnsCustomQueue('analyst');
        this.fetchDynamicFilterAccToQueueId('analyst');
      } else {
        const queueName = __BASEQUEUE_SEARCH_TYPE__;
        this.props.fetchDataColumnsCustomQueue(queueName, null, this.state.selectedBaseQueueItem?.id);
        this.fetchDynamicFilterAccToQueueId(queueName, acquirerAccessCode);
      }
    })
    this.fetchGroupAnalystsDetails(null);
  }

  componentDidMount() {
    let acquirerAccessList = getAcquirerAccessList();
    let acquirerAccessCode;
    if (acquirerAccessList.includes('MXP') && !acquirerAccessList.includes('GPN') && !acquirerAccessList.includes('HPY')) {
      acquirerAccessCode = "MXP";
    } else if (acquirerAccessList.includes('GPN') && !acquirerAccessList.includes('MXP') && !acquirerAccessList.includes('HPY')) {
      acquirerAccessCode = "GPN";
    } else if (acquirerAccessList.includes('HPY') && !acquirerAccessList.includes('MXP') && !acquirerAccessList.includes('GPN')) {
      acquirerAccessCode = "HPY";
    } else {
      acquirerAccessCode = null;
    }

    this.setState({
      sort: Object.assign([], []),
      queueId: getUrlSearchParamValue(this.props.location.search, 'queueid'),
      regionCode: this.state.regionCode != null ? this.state.regionCode : getUrlSearchParamValue(this.props.location.search, 'region'),
      acquirerAccessCode: acquirerAccessCode,
      selectedBaseQueueItemFromUrl: getUrlSearchParamValue(this.props.location.search, 'selectedBaseQueueItem'),
      selectedBaseQueueItem: {
        id: getUrlSearchParamValue(this.props.location.search, 'customQueueId'),
        text: getUrlSearchParamValue(this.props.location.search, 'selectedBaseQueueItem')
      },
      acquirerAccessList: acquirerAccessList
    }, () => this.getBaseQueueGroupList())
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyPress);
    document.removeEventListener('keypress', this.onKeyPress);
  }

  getFormattedResponse(response, filter) {
    let filterValues = [];
    response.data.forEach((filterValue, index) => {
      if (filter === 'cq_case_type') {
        filterValues = filterValues.concat({
          id: filterValue.stageId.toString(),
          value: filterValue.stageId.toString(),
          text: filterValue.stageName,
        });
      }
      if (filter === 'cq_case_status') {
        filterValues = filterValues.concat({
          id: filterValue.statusId.toString(),
          value: filterValue.statusId.toString(),
          text: filterValue.statusName,
        });
      }

      if (filter === 'cq_card_brand') {
        filterValues = filterValues.concat({
          value: filterValue.cardBrandCode.toString(),
          text: filterValue.cardBrandName.toString(),
        });
      }

      if (filter === 'cq_portfolio') {
        filterValues = filterValues.concat({
          value: filterValue.acquirerCode.toString(),
          text: filterValue.acquirerDescription.toString(),
        });
      }

      if (filter === 'cq_pend_indicator') {
        filterValues = filterValues.concat({
          value: filterValue.pendIndicatorCode.toString(),
          text: filterValue.pendIndicatorDesc.toString(),
        });
      }

      if (filter === 'cq_action_category') {
        filterValues = filterValues.concat({
          value: filterValue.categoryCode,
          text: filterValue.categoryDescription,
        });
      }
    });

    if (filter === 'cq_reason_code' || filter === 'cq_activity_code' || filter === 'cq_action_code'
      || filter === 'cq_dispute_currency' || filter === 'cq_trnsctn_currency' || filter === 'cq_sttlmnt_crrncy'
      || filter === 'cq_dspstn_ctgry' || filter === 'cq_mcc') {
      filterValues = this.getFormattedResponseCorpRegion(response.data, filter);
      filterValues = this.groupByRegion(filterValues, filter);
    }
    return filterValues;
  }

  getFormattedResponseCorpRegion(corpRegionResponse, filter) {
    let filterValues = [];
    if (filter === 'cq_reason_code') {
      corpRegionResponse.forEach((filterValue) => {
        filterValues = filterValues.concat({
          id: filterValue.reasonCode,
          value: filterValue.reasonCode,
          text: `${filterValue.reasonCode} : ${filterValue.resonCodeDesc}`,
          groupName: filterValue.cardBrandName,
          groupId: filterValue.cardBrandCode,
        });
      });
    } else if (filter === 'cq_action_code') {
      corpRegionResponse.forEach((filterValue, index) => {
        filterValues = filterValues.concat({
          id: filterValue.actionCode,
          value: filterValue.actionCode,
          text: filterValue.actionDescription,
          groupName: filterValue.actionCode,
          groupId: filterValue.actionCode,
        });
      });
    } else if (filter === 'cq_activity_code') {
      corpRegionResponse.forEach((filterValue, index) => {
        filterValues = filterValues.concat({
          id: filterValue.dispositionCode,
          value: filterValue.dispositionCode,
          text: filterValue.dispositionDescription,
          groupName: filterValue.dispositionCode,
          groupId: filterValue.dispositionCode,
        });
      });
    } else if (filter === 'cq_dispute_currency' || filter === 'cq_trnsctn_currency' || filter === 'cq_sttlmnt_crrncy') {
      corpRegionResponse.forEach((filterValue, index) => {
        filterValues = filterValues.concat({
          id: filterValue.currencyCode,
          value: filterValue.currencyCode,
          text: filterValue.currencyDescription,
          groupName: filterValue.currencyCode,
          groupId: filterValue.currencyCode,
        });
      });
    } else if (filter === 'cq_dspstn_ctgry') {
      corpRegionResponse.filter(obj => obj.categoryType == "disposition").forEach((filterValue, index) => {
        filterValues = filterValues.concat({
          id: filterValue.categoryCode,
          value: filterValue.categoryCode,
          text: filterValue.categoryDescription,
          groupName: filterValue.categoryType,
          groupId: filterValue.categoryType,
        });
      });
    } else if (filter === 'cq_mcc') {
      corpRegionResponse.forEach((filterValue, index) => {
        filterValues = filterValues.concat({
          id: filterValue.mccCode,
          value: filterValue.mccCode,
          text: filterValue.mccDescription,
          groupName: filterValue.mccCode,
          groupId: filterValue.mccCode,
        });
      });
    }
    return filterValues;
  }

  groupByRegion(filterlist, filter) {
    let grp = filterlist.reduce((previous, current) => {
      let nameParts = current.groupName;
      if (!previous[nameParts]) {
        previous[nameParts] = [Object.assign({}, current)];
      } else {
        previous[nameParts].push(Object.assign({}, current));
      }
      return previous;
    }, {});
    let group = Object.keys(grp).map(key => ({ key, items: grp[key], cardBrandCode: grp[key][0].groupId, cardBrandName: grp[key][0].groupName, isIndeterminate: false, selected: false, filterId: filter }));
    this.updateIsIndeterminate(group);
    return group;
  }

  updateIsIndeterminate(filterlist) {
    let that = this;
    each(filterlist, function (analyst) {
      analyst.isIndeterminate = ((!analyst.items.filter(i => {
        return i.selected
      }).length == 0) && (analyst.items.filter(i => {
        return i.selected
      }).length !== analyst.items.length)),
        analyst.selected = analyst.items.filter(i => {
          return i.selected
        }).length == analyst.items.length
    });
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.state.caseData.length !== nextState.caseData.length || this.state.bookMarkedRows.length == 0) {
      nextState.caseData.map((rowVal, index) => {
        if (rowVal.bookmarkedBy) {
          this.setState((prevState) => ({
            bookMarkedRows: prevState.bookMarkedRows.concat(rowVal.caseStageId),
          }));
        }
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    const region = getUrlSearchParamValue(nextProps.location.search, 'region');
    const queueId = getUrlSearchParamValue(nextProps.location.search, 'queueid');
    const userId = getUrlSearchParamValue(nextProps.location.search, 'userid');
    const acquirerAccessCode = this.state.acquirerAccessCode;

    if (this.props.location !== nextProps.location) {
      this.setState({
        activeFiltersValues: [],
      });
      this.fetchHeaderCountData(nextProps.location.search);
    }

    if (this.props.location !== nextProps.location || this.props.pageId !== nextProps.pageId || this.state?.dataColumns?.length == 0 || this.props?.dataColumns?.length !== nextProps.dataColumns?.length) {
      this.setState({
        dataColumns: addIconsToGDTableHeadersList(nextProps.dataColumns, this.state.userPermission),
        sortArr: Object.assign([], []),
      }, () => {
        if (!this.state.isCurrentlySavedFilters)
          this.getDataForDynamicQueueLanding(region, this.state.selectedBaseQueueItem.id, userId, 0, 25, [], this.state.queueSearchView, '', acquirerAccessCode);
      });
      if (userId) {
        this.getUsersQueueName(userId);
      } else {
        this.getQueueNameByRegionAndId(region, queueId, acquirerAccessCode);
      }
      if (this.state.queueId !== queueId) {
        const auth = loadState('auth');
        const userPermission = auth.user.parsedPermissions;
        let queueMetaDataClone = __NON_UNASSIGNABLE_CASES_QUEUES__.find((queueIds) => { return parseInt(queueIds) == parseInt(queueId) }) ? queueMetaData(userPermission, null, true) : queueMetaData(userPermission, this.userIdByLogin, true);
        this.setState({
          queueMetaData: queueMetaDataClone,
          queueId: nextProps.queueId,
          activeFiltersValues: [],
        });
      }
    }

  }

  componentDidUpdate() {
    if (this.state.caseData.length === 1) {
      const myDiv = document.getElementById("BaseQueueLanding");
      if (myDiv !== null) {
        myDiv.style.height = '450px';
      }
    }
  }

  onKeyPress(event) {
    const eventCode = event.code ? (event.code + '_' + event.ctrlKey) : event.key + '_' + event.ctrlKey;
    switch (eventCode) {
      case KeyConstants.ESCAPE_BUTTON:
      case KeyConstants.ESCAPE_KEY_CODE_BUTTON:
        this.closeBanner();
        this.closeSaveFilterFailBanner();
        break;
    }
  }

  getQueueList() {
    return getAllQueueList()
      .then((apiResponse) => {
        const queueListData = apiResponse.data.sort(sort_by('queueName', false, function (a) { return a.toUpperCase() }));

        this.setState({
          queueList: queueListData,
        });
      });
  }

  selectQueue(queueId) {
    let acquirerAccessCode = this.state.acquirerAccessCode;
    const queueName = __BASEQUEUE_SEARCH_TYPE__;
    this.props.fetchDataColumnsCustomQueue(queueName, null, queueId);
    this.setState({
      clearSearchTermValue: true,
      queueSearchView: {
        filterTypeId: 0,
        searchFilterInputElements: []
      },
    });
    this.fetchDynamicFilterAccToQueueId(queueName, acquirerAccessCode);
    this.fetchGroupAnalystsDetails(null, acquirerAccessCode);
  }

  fetchGroupAnalystsDetails(userGroupId, acquirerAccessCode) {
    const acquirerAccessList = getAcquirerAccessList();
    return getGroupAnalystDetails(userGroupId, acquirerAccessList)
      .then((apiResponse) => {
        this.setState({
          currentGroupAnalysts: apiResponse.data ? apiResponse.data.sort(this.compare) : apiResponse.data,
        });
      })
      .catch((error) => {
        this.setState({
          caseDataErr: true,
          isLoading: false
        })
        console.log('Error occured while fetching user details: ', error);
      });
  }
  compare(firstAnalyst, nextAnalyst) {
    // Use toUpperCase() to ignore character casing
    const genreA = firstAnalyst.firstName.toUpperCase();
    const genreB = nextAnalyst.firstName.toUpperCase();

    let comparison = 0;
    if (genreA > genreB) {
      comparison = 1;
    } else if (genreA < genreB) {
      comparison = -1;
    }
    return comparison;
  }
  getCaseStageIdList() {
    let stageIdList = [];
    const filterdRecords = this.state.caseData.filter(dataRow => !this.state.casesToHide.includes(dataRow.caseStageId));
    for (let i = 0; i < filterdRecords.length; i++) {
      stageIdList = stageIdList.concat(filterdRecords[i].caseStageId)
    }
    return stageIdList;
  }
  bulkAssignment(bulkAssignData) {
    this.props.closeNotification();
    const analystText = bulkAssignData.caseAssignementBulkDataList.length > 1 ? `analysts` : `analyst`;
    bulkAssignData.caseStageIdList = this.getCaseStageIdList();
    return bulkAssignment(bulkAssignData)
      .then((apiResponse) => {
        const caseNumberText = apiResponse.data.length > 1 ? `${apiResponse.data.length} cases` : `1 case`;
        const haveOrHas = apiResponse.data.length > 1 ? 'have' : 'has';
        const notificationContent = <div style={{ color: 'black' }}>
          <b>{caseNumberText}</b> {haveOrHas} been successfully assigned to the selected {analystText}.
        </div>

        const notificationMessageSuccess = {
          type: 'success',
          placement: 'topRight',
          messageWidth: 250,
          byDefault: true,
          duration: 5,
          content: notificationContent,
          onClick: this.onNotificationClick,
          customActions: [
            {
              text: 'Undo',
              onClick: () => this.bulkUnAssignment(apiResponse.data),
            }
          ]
        }
        openNotificationToast(notificationMessageSuccess);

        const assignedCaseList = apiResponse.data.map(caseDetail => {
          return parseInt(caseDetail.caseStageID)
        });
        const newCasesToHide = this.state.casesToHide.concat(assignedCaseList)
        const totalRecords = this.state.totalRecords;
        const totalRecordsUpdated = totalRecords - newCasesToHide.length;
        this.setState({
          casesToHide: newCasesToHide,
          resetCaseCount: true,
          totalBulkCases: 0,
          totalRecordsUpdated: totalRecordsUpdated,
        });

        this.fetchGroupAnalystsDetails(null);
      })
      .catch((error) => {

        const notificationMessageError = {
          type: 'error',
          placement: 'topRight',
          messageWidth: 250,
          byDefault: true,
          duration: 5,
          content: <div style={{ color: 'black', paddingTop: 10 }}>
            <b>System Error</b>: Unable to assign cases to selected {analystText}.
          </div>
        };
        openNotificationToast(notificationMessageError);
        console.log('Error occured while assigning cases in bulk: ', error);
      });
  }

  bulkAssignClick(items) {
    let casesCount = 0;
    let sourceQueueIdentifier = {};

    const region = getUrlSearchParamValue(this.props.location.search, 'region');
    const queueId = getUrlSearchParamValue(this.props.location.search, 'queueid');
    const userId = getUrlSearchParamValue(this.props.location.search, 'userid');

    if (userId) {
      sourceQueueIdentifier.userID = userId;
    } else {
      sourceQueueIdentifier.queueID = queueId;
      sourceQueueIdentifier.regionCode = region;
    }

    let formattedData = items.filter(userRow => userRow.numberOfRecordsToAssign > 0);

    let caseAssignementBulkDataList = formattedData.map(userRow => {
      return {
        userID: userRow.userId,
        numberOfCases: userRow.numberOfRecordsToAssign,
      }
    });
    let uniqueUsersList = [];
    let filteredCaseAssignment = [];
    caseAssignementBulkDataList.forEach(obj => {
      const unqIndex = caseAssignementBulkDataList.map(function (e) { return e.userID; }).indexOf(obj.userID);
      if (!uniqueUsersList.includes(unqIndex)) {
        uniqueUsersList.push(unqIndex);
        filteredCaseAssignment.push(obj);
        casesCount = casesCount + obj.numberOfCases;
      }
    });
    const bulAssignmentFormattedData = {
      caseAssignementBulkDataList: filteredCaseAssignment,
      ...sourceQueueIdentifier,
    };

    const caseText = casesCount === 1 ? `${casesCount} case` : `${casesCount} cases`
    const descriptionHtml = <div>The system will select the top <b>{caseText}</b> using filters and sorting applied to the case list below, and assign them to the selected analyst{uniqueUsersList.length > 1 ? 's' : ''}.</div>;

    this.props.setNotification([{
      title: `Bulk Assign ${casesCount} Case${casesCount > 1 ? 's' : ''}?`,
      descriptionStyle: "color: 'grey'",
      descriptionHtml: descriptionHtml,
      primaryButtonText: 'ASSIGN THE CASES',
      primaryButtonAction: () => this.bulkAssignment(bulAssignmentFormattedData),
      type: 'info',
      noActions: false,
      closeNotification: () => this.props.closeNotification(),
      cancelButtonText: 'CANCEL',
      valueStyle: "color: 'black'",
    }]);
  }

  onAssignClick = (userData, type) => {
    if (type === 'assignToRegion') {
      const formattedRequestBody = {
        caseStageID: this.state.selectedRows,
        userGroupID: userData.userGroupId,
      };

      this.assignCasesToGroup(this.state.selectedRows, userData, formattedRequestBody);
    }
    if (type === 'assignToUser') {
      const formattedRequestData = this.formatRequestBody(this.state.selectedRows, userData.userId)
      this.assignCase(true, this.state.selectedRows, userData, formattedRequestData);
    }
  }

  bulkUnAssignment(bulkUnAssignmentData) {

    return unAssignCase(bulkUnAssignmentData)
      .then((apiResponse) => {
        const caseNumberText = bulkUnAssignmentData.length > 1 ? `${bulkUnAssignmentData.length} cases` : `1 case`;
        const haveOrHas = bulkUnAssignmentData.length > 1 ? 'have' : 'has';
        const notificationContent = <div style={{ color: 'black' }}>
          <b>{caseNumberText}</b> {haveOrHas} been unassigned from selected analyst{bulkUnAssignmentData.length > 1 ? 's' : ''}.
        </div>

        const notificationMessageSuccess = {
          type: 'info',
          placement: 'topRight',
          messageWidth: 250,
          byDefault: true,
          duration: 5,
          content: notificationContent,
        }
        openNotificationToast(notificationMessageSuccess);
        const totalRecordsNew = this.state.totalRecordsUpdated + bulkUnAssignmentData.length;
        const newCasesToHide = [];
        this.state.casesToHide.forEach(hcase => {
          bulkUnAssignmentData.forEach(bcase => {
            if (bcase.caseStageID !== `${hcase}`) {
              newCasesToHide.push(hcase);
            }
          })
        });
        this.setState({
          casesToHide: newCasesToHide,
          totalRecordsUpdated: totalRecordsNew,
        });

        this.fetchGroupAnalystsDetails(null);
      })
      .catch((error) => {
        // TODO: Error Notification on un-Assign Case.
        const notificationMessageError = {
          type: 'error',
          placement: 'topRight',
          messageWidth: 250,
          byDefault: true,
          duration: 5,
          content: <div style={{ color: 'black', paddingTop: 10 }}>
            <b>System Error</b>: Unable to un-assign selected case{bulkUnAssignmentData.length > 1 ? 's' : ''}.
          </div>,
        };

        openNotificationToast(notificationMessageError);
        console.log('error occured while un-assigning a case.', error);
      });
  }

  refreshTimeFeed() {
    const region = getUrlSearchParamValue(this.props.location.search, 'region');
    const queueId = getUrlSearchParamValue(this.props.location.search, 'queueid');
    const userId = getUrlSearchParamValue(this.props.location.search, 'userid');
    const acquirerAccessCode = this.state.acquirerAccessCode;

    // API Call
    const timeBoxDataClone = { ...this.state.timeBoxData };
    timeBoxDataClone.date = new Date();
    timeBoxDataClone.isRefreshRequired = true;
    timeBoxDataClone.text = 'Last refreshed';
    this.setState({
      dataColumns: addIconsToGDTableHeadersList(this.state.dataColumns, this.state.userPermission),
      timeBoxData: timeBoxDataClone,
      caseData: [],
      isRefreshed: true,
      casesToHide: [],
      totalRecordsUpdated: this.state.totalRecords,
      // isLoading:true
    }, () => {
      this.fetchHeaderCountData(this.props.location.search);
      this.getDataForDynamicQueueLanding(region, this.state.selectedBaseQueueItem.id, userId, 0, 25, this.state.sortArr, this.state.queueSearchView, '', acquirerAccessCode);
      this.getRegionCodeHeaderData(this.state.queueSearchView);
    });
  }

  getUsersQueueName(userId) {
    let acquirerAccessList = getAcquirerAccessList();
    getGroupAnalystDetails(null, acquirerAccessList).then((response) => {
      const userDetail = response.data.find((userRow) => {
        return parseInt(userRow.userId) === parseInt(userId);
      });
      this.setState({
        tableName: `${userDetail.firstName}'s Queue`,
        selectedQueueData: userDetail,
      });
    }).catch((error) => {
      console.log('Error Occured while fetching queue Name from my queue', error);
    });
  }

  getQueueNameByRegionAndId(regionCode, queueId, acquirerAccessCode) {

    if (parseInt(queueId) === 69) {
      getMyQueues().then((response) => {
        const queueList = response.data;

        const queueData = queueList.find((queueRow) => {
          return parseInt(queueRow.queueId) === parseInt(queueId);
        });

        this.setState({
          tableName: this.state.selectedBaseQueueItem.text,
          selectedQueueData: queueData,
        });
      });

    } else if (parseInt(queueId) === 70) {
      getBookMarkedCases().then((response) => {
        const queueList = response.data;
        this.setState({
          tableName: "My Bookmarked Cases ",
          selectedQueueData: queueList,
        });
      })
        .catch((error) => {
          console.log('Error Occured while fetching My BookMarked Cases', error);
          this.setState({
            tableName: "My Bookmarked Cases ",
            caseDataErr: true,
            isLoading: false
          });
        });
    }
    else {
      this.setState({
        tableName: this.state.selectedBaseQueueItem.text,
      });
    }
  }

  getDataForDynamicQueueLanding(regionCode, queueId, userId, pageNumber, size, sortArr, queueSearchView, lazyLoad, acquirerAccessCode) {
    lazyLoad = false;
    const queueMetaDataClone = { ...this.state.queueMetaData };
    queueMetaDataClone.dataColumns = [...this.state.dataColumns];
    let acquirerList = getAcquirerAccessList();
    let pinDebitAcquirerCodes = acquirerList.filter(item => item.endsWith('PD'));
    return getDataForDynamicQueueLanding(this.state.regionCode, this.state.selectedBaseQueueItem.id, userId, pageNumber, size, sortArr, queueSearchView, acquirerAccessCode, __BASEQUEUE_SEARCH_TYPE__, pinDebitAcquirerCodes)
      .then((apiResponse) => {
        const formattedData = apiResponse.data.content;
        this.setState((prevState) => ({
          queueMetaData: queueMetaDataClone,
          caseData: lazyLoad ? prevState.caseData.concat(formattedData) : formattedData,
          totalRecords: apiResponse.data.totalElements,
          totalPages: apiResponse.data.totalPages,
          currentPage: apiResponse.data.number + 1,
          recordsShown: size,
          isNextPage: !apiResponse.data.last,
          caseDataErr: false,
          isLoading: false,
          sortArr,
          isTableVisible: true,
          selectedRows: [],
          agLoader: false,
          isCurrentlySavedFilters: false,
          statusErrorCode: apiResponse.status.statusCode,
        }));
        scroll(0, 0);
      })
      .catch((error) => {
        this.setState({ caseDataErr: true, isLoading: false, statusErrorCode: error && error.response && queueId != 69 ? error.response.status : undefined });
        console.log('Error Occured while fetching data based on global applied filters', error);
      });
  }

  fetchDynamicFilterAccToQueueId(queueId, acquirerAccessCode) {
    let commonArr = [];
    let acquirerAccessList = getAcquirerAccessList();
    return getDynamicFitlersAccCustomQueue(queueId, this.state.selectedBaseQueueItem.id)
      .then((apiResponse) => {
        if (apiResponse.status.statusCode === 2000) {
          this.setState({
            activeFilters: formatActiveFilters(apiResponse.data.activeFilterElements),
            availableFilters: formatAvailableFilters(apiResponse.data.availableFilterElements),
            filterTypeId: apiResponse.data.filterTypeId,
            caseDataErr: false,
            isLoading: false,
          }, () => {
            this.fetchSavedFilterValues(this.state.filterTypeId);
            commonArr = this.state.activeFilters.concat(this.state.availableFilters);
            commonArr.forEach((filter) => {
              if ((filter.elementTypeName === 'DYNAMIC_MULTISELECT' || filter.elementTypeName === 'GROUP_SEARCH') && urlRelativeMapping[filter.elementId]) {
                if ((filter.elementId === 'cq_card_brand' || filter.elementId === 'cq_reason_code') && acquirerAccessList) {
                  getFilterValuesBasedOnElementIdWithAcquirer(filter.elementId, acquirerAccessList)
                    .then((response) => {
                      if (response.status.statusCode === 2000) {
                        this.formatResponseCommon(response, filter.elementId);
                      }
                    })
                    .catch((error) => {
                      this.setState({
                        isLoading: false,
                      })
                      console.log('Error Occured while fetching filter values based on element id', error);
                    });
                } else {
                  getFilterValuesBasedOnElementId(filter.elementId)
                    .then((response) => {
                      if (response.status.statusCode === 2000) {
                        this.formatResponseCommon(response, filter.elementId);
                      }
                    })
                    .catch((error) => {
                      this.setState({
                        isLoading: false,
                      })
                      console.log('Error Occured while fetching filter values based on element id', error);
                    });
                }
              }
              if (urlMapping[filter.elementId]) {
                fetchFilterValuesBasedOnElementId(filter.elementId).then((response) => {
                  if (response.status.statusCode === 2000) {
                    this.formatResponseCommon(response, filter.elementId);
                  }
                })
                  .catch((error) => {
                    this.setState({
                      isLoading: false,
                    })
                    console.log('Error Occured while fetching filter values based on element id', error);
                  });
              }
              if (filter.elementId === 'cq_dspstn_ctgry') {
                getQueueLabels(true).then((response) => {
                  if (response.status.statusCode === 2000) {
                    this.formatResponseCommon(response, filter.elementId);
                  }
                })
                  .catch((error) => {
                    this.setState({
                      isLoading: false,
                    })
                    console.log('Error Occured while fetching queue labels', error);
                  });
              }
            })
          });

        }
      })
      .catch((error) => {
        this.setState({
          caseDataErr: true,
          isLoading: false
        })
        console.log('Error Occured while fetching filter values based on element id', error);
      })
  }

  getMultiSelectFilterValues() {
    let activeFilters = [];
    activeFilters = this.state.activeFilters.map((filter) => {
      if (filter.elementTypeName === 'DYNAMIC_MULTISELECT' || filter.elementTypeName === 'GROUP_SEARCH' || filter.elementTypeName === 'DROPDOWN') {
        return {
          filterValues: this.state[filter.elementId],
          ...filter
        }
      } else {
        return filter;
      }
    });
    this.setState({
      formattedFilters: activeFilters,
    });
    return activeFilters;
  }

  saveActiveDynamicFilters(activeFilters, newFilterValues, corp, regionCode) {
    const region = this.state.regionCode;
    const userId = getUrlSearchParamValue(this.props.location.search, 'userid');
    const acquirerAccessCode = this.state.acquirerAccessCode;

    let filterTypeId = this.state.filterTypeId;
    let activeFilterValues = newFilterValues;
    let searchFilterInputElements = splitMergedElementIdsFilterValues(activeFilterValues, activeFilters, corp, regionCode).filter(data => data.elementValue !== '');
    let queueSearchView = {
      filterTypeId: filterTypeId,
      searchFilterInputElements: searchFilterInputElements
    };
    return postActiveDynamicFilters(this.state.filterTypeId, activeFilters, this.state.selectedBaseQueueItem.id)
      .then((apiResponse) => {
        if (apiResponse.status.statusCode === 2000) {
          this.setState({
            queueSearchView,
            isLoading: true,
            caseDataErr: false,
          }, () => {
            this.getDataForDynamicQueueLanding(region, this.state.selectedBaseQueueItem.id, userId, 0, 25, this.state.sort, queueSearchView, '', acquirerAccessCode);
            this.getRegionCodeHeaderData(queueSearchView);
          });
        }
      })
      .catch((error) => {
        this.setState({ caseDataErr: true, isLoading: false });
        console.log('Error Occured while saving dynamic active filters', error);
      })
  }

  pageHandler = (newPage, newPerPage) => {
    const region = getUrlSearchParamValue(this.props.location.search, 'region');
    const queueId = getUrlSearchParamValue(this.props.location.search, 'queueid');
    const userId = getUrlSearchParamValue(this.props.location.search, 'userid');
    const acquirerAccessCode = this.state.acquirerAccessCode;

    this.setState({
      isLoading: true,
      caseDataErr: false,
    });

    const pageSize = newPerPage === undefined ? this.state.recordsShown : newPerPage;
    if (newPage) {
      this.getDataForDynamicQueueLanding(region, this.state.selectedBaseQueueItem.id, userId, newPage - 1, pageSize, this.state.sortArr, this.state.queueSearchView, '', acquirerAccessCode);
    }
  }

  onSearchChange = (filterText) => {
    this.setState({ filterText });
  }

  handleSort = (key, sortArr) => {
    const queueId = getUrlSearchParamValue(this.props.location.search, 'queueid');
    const region = getUrlSearchParamValue(this.props.location.search, 'region');
    const userId = getUrlSearchParamValue(this.props.location.search, 'userid');
    const acquirerAccessCode = this.state.acquirerAccessCode;

    this.setState({
      currentPage: 1,
      agLoader: true,
      isLoading: true,
      caseDataErr: false,
      sortArr,
    });

    this.getDataForDynamicQueueLanding(region, this.state.selectedBaseQueueItem.id, userId, 0, this.state.recordsShown, sortArr, this.state.queueSearchView, '', acquirerAccessCode);
  }

  toggleFileExport = () => {
    this.setState({ filterExportIsVisible: !this.state.filterExportIsVisible });
  }

  onRowClick = (event, sequenceKey) => {
    if ((!event.target.id &&
      !event.target.classList.contains('gd-row-actions') &&
      !event.target.classList.contains('dropdown-menu-trigger')) ||
      event.target.parentNode.classList.contains('primary')) {
      alert(`Row #${sequenceKey} clicked.`); // eslint-disable-line
    }
  }

  rowActionClick(selectedKeyIndex, key) {
    this.setState({
      selectedKeyIndex,
    });

    if (key === 'OPEN_CASE') {
      this.gotoCaseLandingPage(selectedKeyIndex);
    }
    if (key === "OPEN_CASE_IN_TAB") {
      gotoNewTabCaseLandingPage(this.state.caseData[selectedKeyIndex].caseNumber);
    }
    if (key === 'UNASSIGN_CASE') {
      const formattedRequestData = this.formatRequestBody([this.state.caseData[selectedKeyIndex].caseStageId], this.state.caseData[selectedKeyIndex].caseAssignTo)
      this.unAssignCase(true, [this.state.caseData[selectedKeyIndex].caseStageId], this.state.selectedQueueData, formattedRequestData);
    }
  }
  onBookMarked(key, caseStageId) {
    const rowData = this.state.caseData[key].caseStageId;
    let presenceIndex = this.state.bookMarkedRows.findIndex(row => row === caseStageId);
    if (rowData) {
      if (presenceIndex === -1) {
        return postBookMarkCase(rowData)
          .then(() => {
            this.setState((prevState) => ({
              bookMarkedRows: prevState.bookMarkedRows.concat(caseStageId),
            }));
          })
          .catch((error) => {
            console.log('Error Occured while Bookmarking the case', error);
          });
      }
      else {
        return undoBookMarkCase(rowData)
          .then(() => {
            const queueId = getUrlSearchParamValue(this.props.location.search, 'queueid');
            if (queueId == 70) {
              this.refreshTimeFeed();
            }
            else {
              this.setState((prevState) => ({
                bookMarkedRows: prevState.bookMarkedRows.filter(row => row !== caseStageId),
              }));
            }
          })
          .catch((error) => {
            console.log('Error Occured while un-bookmarking the case', error);
          });
      }
    }
  }
  gotoCaseLandingPage(selectedKeyIndex) {
    this.props.history.push({
      state: {
        data: this.state.caseData[selectedKeyIndex],
        prevPath: this.props.location.pathname,
      },
      pathname: '/caselanding/' + `${this.state.caseData[selectedKeyIndex].caseNumber}`,
    });
  }

  saveCurrentlyVisibleColumns(columns) {
    const userId = getUrlSearchParamValue(this.props.location.search, 'userid');
    let pageId = '';

    // Save columns as per the regional queue and user queue.
    if (userId) {
      pageId = 'analyst';
    } else {
      pageId = __BASEQUEUE_SEARCH_TYPE__;
    }

    this.setState({
      dataColumns: columns,
    });

    const activeDataColumns = [];
    columns.forEach((column) => {
      if (column.displayType !== 'ICON') {
        const activeColumn = {
          columnId: column.columnId,
          displayOrder: column.displayOrder,
        };
        activeDataColumns.push(activeColumn);
      }
    });

    this.postActiveFilters(activeDataColumns, pageId);
  }

  postActiveFilters(columns, pageId) {
    return postActiveFilters(pageId, columns, this.state.selectedBaseQueueItem.id)
      .then(() => {
        this.props.fetchDataColumnsCustomQueue(pageId, null, this.state.selectedBaseQueueItem.id);
        this.setState({
          caseDataErr: false,
          isLoading: false,
          isCurrentlySavedFilters: true,
        });
      })
      .catch((error) => {
        this.setState({ caseDataErr: true, isLoading: false });
        console.log('Error Occured while saving active data columns', error);
      });
  }

  toggleFilterPane() {
    document.body.classList.add('instant-header');
    scroll(0, 0);
    this.setState(
      {
        isVisible: !this.state.isVisible,
      },
    );
  }

  // eslint-disable-next-line no-undef
  exportAction = (fileObject) => {
    this.toggleFileExport();
    let isAllColumns = fileObject.exportType.value === 'all-columns' ? true : false;
    let fileType = fileObject.fileType.value;
    let fileName = fileObject.fileName;
    this.state.totalRecords > 25000 ?
      this.setState({
        setSize: true,
      })
      :
      this.exportFile(fileName, fileType, isAllColumns);
  }

  exportFile(fileName, fileType, isAllColumns) {
    const queueId = getUrlSearchParamValue(this.props.location.search, 'queueid');
    const region = this.state.regionCode;
    const userId = getUrlSearchParamValue(this.props.location.search, 'userid');
    let pageId = '';

    if (userId) {
      pageId = 'analyst';
    } else {
      pageId = (queueId == 69 || queueId == 70) ? `queue_mgmt_${queueId}` : `${region.toLowerCase()}_${queueId}`;
    }
    let sortKeyString = [];
    let sortOrderString = [];
    this.state.sortArr.forEach((element) => {
      sortKeyString.push(element.key);
      sortOrderString.push(element.order ? 'ASC' : 'DESC');
    });
    let acquirerList = getAcquirerAccessList();
    let pinDebitAcquirerCodes = acquirerList.filter(item => item.endsWith('PD'));
    let queueExportData = {
      fileType: fileType,
      isAllColumns: isAllColumns,
      pageId: __BASEQUEUE_SEARCH_TYPE__,
      queueManagerUserDataRequest: {
        orderByProperties: sortKeyString,
        pageNumber: 0,
        propertyDirections: sortOrderString,
        size: this.state.headerCountData.workableCount,
        queueSearchView: {
          filterTypeId: this.state.exportFilterTypeId,
          searchFilterInputElements: splitMergedElementIdsFilterValues(this.state.activeFiltersValues).filter(data => data.elementValue !== '')
        },
        regionCode: region,
        queueId: this.state.selectedBaseQueueItem.id,
        userId: userId,
        acquirerAccessCode: this.state.acquirerAccessCode,
        acquirerCodes: pinDebitAcquirerCodes,
      }
    }
    this.setState({ exporting: true });
    exportUserQueueData(queueExportData, this.state.selectedBaseQueueItem.id, __BASEQUEUE_SEARCH_TYPE__).then((response) => {
      downloadFile(fileName, fileType, response);
      this.setState({ exporting: false });
    })
      .catch((error) => {
        this.setState({ exporting: false });
        console.log('Error Occured while exporting the case', error);
      });
  }
  checkSize() {
    this.props.setNotification([{
      title: `Error Occured`,
      descriptionStyle: "color: 'grey'",
      description: 'Your export request has exceeded the limitation of 25,000 rows.  Please apply additional filters to reduce of number rows.',
      type: 'danger',
      noActions: true,
      closeNotification: () => this.props.closeNotification(),
    }]);
    this.setState({
      setSize: false,
    })
  }

  fetchHeaderCountData(searchData) {
    const userId = getUrlSearchParamValue(searchData, 'userid');

    if (userId) {
      this.getAssignedCasesHeaderData(userId);
    } else {
      const region = getUrlSearchParamValue(searchData, 'region');
      const queueid = getUrlSearchParamValue(searchData, 'queueid');
      let acquirer = this.state.acquirerAccessCode;
      let acquirerList = [];
      if (acquirer == "MXP") {
        acquirerList = [acquirer, "MXI"];
      } else {
        acquirerList = [acquirer];
      }
    }
  }

  getAssignedCasesHeaderData(userId) {
    return getAssignedCasesHeaderData(userId)
      .then((apiResponse) => {
        this.setState({
          headerCountData: apiResponse.data,
        });
      })
      .catch((error) => {
        console.log('error fetching assigned cases header count details', error);
      });
  }

  getRegionCodeHeaderData(queueSearchView) {
    let acquirerList = getAcquirerAccessList();
    let pinDebitAcquirerCodes = acquirerList.filter(item => item.endsWith('PD'));
    let item = this.state.selectedBaseQueueItem;
    return getQueueSummary(item.queueGroupCode, item.actionCategoryCode, null, null, queueSearchView, pinDebitAcquirerCodes)
      .then((apiResponse) => {
        this.setState({
          headerCountData: apiResponse.data,
        });
      })
      .catch((error) => {
        console.log('error fetching reason code header count details', error);
      });
  }

  onCheckboxClick(key) {
    this.props.closeNotification();
    if (Array.isArray(key)) {
      this.setState({
        selectedRows: key,
      });
    } else {
      let presenceIndex = this.state.selectedRows.findIndex(row => row === key);
      // Add to selected items or remove if already present.
      this.setState({
        selectedRows: presenceIndex === -1 ? this.state.selectedRows.concat(key) : this.state.selectedRows.filter(row => row !== key),
      });
    }
  }

  assignCasesToGroup(selectedCases, userGroupData, formattedRequestBody) {
    if (selectedCases.length < 1) {
      this.handleCaseSelectionValidation();
    } else {
      const caseNumberText = selectedCases.length > 1 ? `${selectedCases.length} cases` : `Case ${this.state.caseData.find(dataRow => dataRow.caseStageId === selectedCases[0]).caseNumber}`;
      const haveOrHas = selectedCases.length > 1 ? 'have' : 'has';
      return assignCasesToGroup(formattedRequestBody)
        .then((apiResponse) => {

          // TODO: Sucess Notification on Assign Case.
          const notificationContent = <div style={{ color: 'black' }}>
            <b>{caseNumberText}</b> {haveOrHas} been successfully assigned to <b>{userGroupData.key}</b>
          </div>

          const notificationMessageSuccess = {
            type: 'success',
            placement: 'topRight',
            messageWidth: 250,
            byDefault: true,
            duration: 5,
            content: notificationContent,
            onClick: this.onNotificationClick,
            customActions: [
              {
                text: 'Undo',
                onClick: () => this.unAssignCase(false, selectedCases, userGroupData, apiResponse.data),
              }
            ]
          };

          openNotificationToast(notificationMessageSuccess);
          this.fetchGroupAnalystsDetails(null);
          const newCasesToHide = this.state.casesToHide.concat(selectedCases);
          const totalRecords = this.state.totalRecords;
          const totalRecordsUpdated = totalRecords - newCasesToHide.length;
          this.setState({
            selectedRows: [],
            casesToHide: newCasesToHide,
            totalRecordsUpdated: totalRecordsUpdated,
            displayFloatingPanel: false,
            dragOvertText: DEFAULT_DRAG_OVER_TEXT,
            caseDataErr: totalRecordsUpdated === 0 ? true : false,
          });
        })
        .catch((error) => {
          // TODO: Error Notification on un-Assign Case.
          const notificationMessageError = {
            type: 'error',
            placement: 'topRight',
            messageWidth: 250,
            byDefault: true,
            duration: 5,
            content: <div style={{ color: 'black', paddingTop: 10 }}>
              <b>System Error</b>: Unable to assign selected case{selectedCases.length > 1 ? 's' : ''}.
            </div>
          };
          openNotificationToast(notificationMessageError);
          console.log('error occured while assigning a case.', error);
        });
    }
  }


  handleCaseSelectionValidation() {
    this.props.setNotification([{
      title: 'Please select at least one case to assign',
      descriptionStyle: "color: 'grey'",
      type: 'danger',
      cancelButtonText: 'CLOSE',
      cancelOnly: true,
      closeNotification: () => this.props.closeNotification(),
      valueStyle: "color: 'black'",
    }]);
  }

  assignCase(isUndoEnable, selectedCases, userData, formattedRequestData) {

    // TODO: UPDATE when API is integrated.
    if (selectedCases.length < 1) {
      this.handleCaseSelectionValidation();
    } else {
      const userName = `${userData.firstName} ${userData.lastName}`;
      const caseNumberText = selectedCases.length > 1 ? `${selectedCases.length} cases` : `Case ${this.state.caseData.find(dataRow => dataRow.caseStageId === selectedCases[0]).caseNumber}`;
      const haveOrHas = selectedCases.length > 1 ? 'have' : 'has';
      return assignCase(formattedRequestData)
        .then((apiResponse) => {

          // TODO: Sucess Notification on Assign Case.
          const notificationContent = <div style={{ color: 'black' }}>
            <b>{caseNumberText}</b> {haveOrHas} been successfully assigned to <b>{userName}</b>
          </div>

          const notificationMessageSuccess = {
            type: 'success',
            placement: 'topRight',
            messageWidth: 250,
            byDefault: true,
            duration: 5,
            content: notificationContent,
            onClick: this.onNotificationClick,
            customActions: isUndoEnable ? [
              {
                text: 'Undo',
                onClick: () => this.unAssignCase(false, selectedCases, userData, apiResponse.data),
              }
            ] : []
          };

          openNotificationToast(notificationMessageSuccess);
          this.fetchGroupAnalystsDetails(null);
          const newCasesToHide = this.state.casesToHide.concat(selectedCases);
          const totalRecords = this.state.totalRecords;
          const totalRecordsUpdated = totalRecords - newCasesToHide.length;
          this.setState({
            selectedRows: [],
            casesToHide: newCasesToHide,
            totalRecordsUpdated: totalRecordsUpdated,
            displayFloatingPanel: false,
            dragOvertText: DEFAULT_DRAG_OVER_TEXT,
            caseDataErr: totalRecordsUpdated === 0 ? true : false,
          });
        })
        .catch((error) => {
          // TODO: Error Notification on un-Assign Case.
          const notificationMessageError = {
            type: 'error',
            placement: 'topRight',
            messageWidth: 250,
            byDefault: true,
            duration: 5,
            content: <div style={{ color: 'black', paddingTop: 10 }}>
              <b>System Error</b>: Unable to assign selected case{selectedCases.length > 1 ? 's' : ''}.
            </div>,
          };
          openNotificationToast(notificationMessageError);
          console.log('error occured while assigning a case.', error);
        });
    }
  }

  onNotificationClick(clickData) {
  }

  formatRequestBody(selectedCases, userId) {
    return selectedCases.map(selectedCaseStageId => {
      return {
        userID: userId,
        caseStageID: `${selectedCaseStageId}`,
        undo: false,
      }
    });
  }

  unAssignCase(isUndoEnable, selectedCases, userData, formattedRequestBody) {
    this.props.closeNotification();

    return unAssignCase(formattedRequestBody)
      .then((apiResponse) => {
        const userName = userData.firstName === undefined ? userData.key : `${userData.firstName} ${userData.lastName}`;
        const caseNumberText = selectedCases.length > 1 ? `${selectedCases.length} cases` : `Case ${this.state.caseData.find(dataRow => dataRow.caseStageId === selectedCases[0]).caseNumber}`;
        const haveOrHas = selectedCases.length > 1 ? 'have' : 'has';
        // TODO: Sucess Notification on un Assign Case.
        const notificationContent = <div style={{ color: 'black' }}>
          <b>{caseNumberText}</b> {haveOrHas} been unassigned from <b>{userName}</b>
        </div>

        const notificationMessageSuccess = {
          type: 'info',
          placement: 'topRight',
          messageWidth: 250,
          byDefault: true,
          duration: 5,
          content: notificationContent,
          customActions: isUndoEnable ? [
            {
              text: 'Undo',
              onClick: () => this.assignCase(false, selectedCases, userData, apiResponse.data),
            }
          ] : []
        }
        openNotificationToast(notificationMessageSuccess);
        this.fetchGroupAnalystsDetails(null);
        const totalRecordsNew = this.state.totalRecordsUpdated + selectedCases.length;
        const newCasesToHide = this.state.casesToHide.filter(hcase => !selectedCases.includes(hcase));
        this.setState({
          casesToHide: newCasesToHide,
          totalRecordsUpdated: totalRecordsNew,
        });

      })
      .catch((error) => {
        // TODO: Error Notification on un-Assign Case.
        const notificationMessageError = {
          type: 'error',
          placement: 'topRight',
          messageWidth: 250,
          byDefault: true,
          duration: 5,
          content: <div style={{ color: 'black', paddingTop: 10 }}>
            <b>System Error</b>: Unable to un-assign selected case{selectedCases.length > 1 ? 's' : ''}.
          </div>,
        };
        openNotificationToast(notificationMessageError);
        console.log('error occured while un-assigning a case.', error);
      });

  }

  onKeyDown(event) {
    if (event.keyCode == 27) {
      this.setState({
        displayFloatingPanel: false,
        selectedRows: [],
      });
    }
  }


  setTotalBulkCases(totalCases) {
    const isCheckboxEnabled = totalCases > 0 ? false : true;
    let queueMetaDataClone = { ...this.state.queueMetaData };
    queueMetaDataClone.isCheckboxOnRowRequired = isCheckboxEnabled;
    this.setState({
      totalBulkCases: totalCases,
      resetCaseCount: false,
      queueMetaData: queueMetaDataClone,
    });
  }

  closeFilterPane = () => {
    scroll(0, 0);
    this.setState({ isVisible: false });
  }

  resetScrollPos() {
    this.setState({
      scrollPos: 0,
    });
  }

  applyFilters(newValues, filterList, corp, region, corpRegion) {
    const newFilterValues = convertJsonObjectToArray(newValues, filterList);
    let element;
    if (newFilterValues.length === 1) {
      element = Object.keys(newValues).map((key) => { return key; });
    }
    if (newFilterValues.length === 0 || (newFilterValues.length === 1 && element[0] === 'acquirerCode')) {
      this.setState({
        isRequiredFilter: true,
        isVisible: true,
      })
    }
    else {
      this.setState({
        activeFiltersValues: mapActiveFilters(newFilterValues, filterList),
        isVisible: false,
        exportFilterTypeId: this.state.filterTypeId,
        corp: corp,
        region: region,
        corpRegion: corpRegion
      })

      this.saveActiveDynamicFilters(splitMergedElementIdsFilters(filterList), mapActiveFilters(newFilterValues, filterList), corp, region, corpRegion);
      this.getMultiSelectFilterValues();
    }
  }

  updateColumnsInfo(columns) {
    scroll(0, 0);
    this.setState({
      activeFilters: columns.activeColumns,
      availableFilters: columns.availableColumns,
    })
    if (columns.identifier) {
      const newFilterValues = convertJsonObjectToArray(columns.currentValues, columns.filterList);
      this.setState(() => ({
        activeFiltersValues: mapActiveFilters(newFilterValues.filter(data => data && data.id !== columns.identifier), columns.filterList)
      }))
    }
    const finalFilterElements = columns.activeColumns.map((filterElement) => {
      if (filterElement.elementTypeName === 'DYNAMIC_MULTISELECT' || filterElement.elementTypeName === 'GROUP_SEARCH' || filterElement.elementTypeName === 'DROPDOWN') {
        return {
          filterValues: this.state[filterElement.elementId],
          ...filterElement,
        };

      } else {
        return filterElement;
      }
    });

    this.setState({
      formattedFilters: finalFilterElements,
      dynamicFilterFlag: true,
    });

  }

  closeBanner() {
    this.setState({
      isRequiredFilter: false,
      //multiSelectFiltersIds
    })
  }
  toggleDropdown(event) {
    event.persist();
    const id = event.currentTarget.id;
    const dropdownToggled = this.state.dropdownToggled;
    dropdownToggled[`${id}`] = !dropdownToggled[`${id}`];
    this.setState({ dropdownToggled });
  }

  deactivateFilter(id) {
    const newFilters = this.state.activeFiltersValues.filter((filter) => {
      return filter.id !== id;
    });
    this.setState(
      {
        activeFiltersValues: mapActiveFilters(newFilters, this.state.activeFilters),
        savedFilters: mapSavedFilters(this.state.savedFilters, newFilters),
      }
    );
  }

  clearAllFilters() {
    this.clearGroupSearchValue();
    this.setState(
      {
        clearSearchTermValue: true,
        activeFiltersValues: [],
        savedFilters: mapSavedFilters(this.state.savedFilters),
        queueSearchView: {
          "filterTypeId": 0,
          "searchFilterInputElements": []
        },
      }
    );
    this.refreshTimeFeed();
  }

  clearGroupSearchValue() {
    this.state.formattedFilters.map((element) => {
      if (element.elementTypeName === 'GROUP_SEARCH') {
        for (let i = 0; i < element.filterValues.length; i++) {
          element.filterValues[i].selected = false;
          let items = element.filterValues[i].items;
          for (let j = 0; j < items.length; j++) {
            items[j].selected = false;
          }
        }
      }
    })
  }
  saveFilterName() {
    const updateIndex = this.state.savedFilters.findIndex((caseObject) => {
      return caseObject.filterName === this.state.filterName;
    });
    if (updateIndex == -1) {
      return postActiveFilterValues(this.state.filterTypeId, splitMergedElementIdsFilterValuesSaveFilter(this.state.activeFiltersValues, this.state.activeFilters, this.state.corpRegion), this.state.filterName, this.state.selectedBaseQueueItem.id)
        .then((apiResponse) => {
          if (apiResponse.status.statusCode === 2000) {
            this.setState({ filterName: '', saveFilterToggled: false, caseDataErr: false, isLoading: false });
            this.fetchSavedFilterValues(this.state.filterTypeId);
          }
        })
        .catch((error) => {
          this.setState({ caseDataErr: true, isLoading: false, filterName: '' });
          console.log('Error Occured while saving active filter values with name', error);
        })
    } else {
      this.setState({
        saveFilterFail: true,
        filterName: '',
      });
    }

  }

  fetchSavedFilterValues(filterTypeId) {
    getSavedFiltersBasedOnSearchTypeId(filterTypeId, this.state.selectedBaseQueueItem.id)
      .then((apiResponse) => {
        this.setState({
          savedFilters: mergeSavedElementIdsForRangeElements(apiResponse.data),
          noSavedFilters: apiResponse.data.length > 0 ? false : true,
          tempSavedFilters: apiResponse.data,
          isLoading: apiResponse.data.length > 0 ? false : this.state.isLoading,
          caseDataErr: apiResponse.data.length > 0 ? false : this.state.caseDataErr,
        })
      })
      .catch((error) => {
        this.setState({ isLoading: false, noSavedFilters: true });
        console.log('Error Occured while fetching active filter values', error);
      })
  }

  toggleSavedFilter = () => {
    this.setState({ saveFilterToggled: !this.state.saveFilterToggled });
  };

  onChange(event) {
    if (event.target) {
      this.setState({ [event.target.name]: event.target.value });
    }
  }

  updateSearchField(value) {
    const lowercaseSearchTerm =
      value && value.toLowerCase && value.toLowerCase();
    const filteredFilters = this.state.tempSavedFilters.filter((filter) => {
      // the most redundant, yet appropriate name ever
      const lowercaseFilterName = filter.filterName.toLowerCase();
      return lowercaseFilterName.includes(lowercaseSearchTerm);
    });
    this.setState({
      currentSearchTerm: value,
      savedFilters: mergeSavedElementIdsForRangeElements(filteredFilters),
    });
  }

  removeSavedFilter(id) {
    const newFilters = this.state.savedFilters.filter((filter) => {
      return filter.id !== id;
    });
    this.setState(
      {
        savedFilters: newFilters,
        isOpenSavedFilterDropdown: false,
      },
      () => {
        const body = document.querySelector('body');
        const e = document.createEvent('MouseEvents');
        e.initEvent('mousedown', true, true);
        body.dispatchEvent(e);
      },
    );

    return deleteSavedFilter(id)
      .then((apiResponse) => {
        if (apiResponse.status.statusCode === 2000) {
          this.fetchSavedFilterValues(this.state.filterTypeId);
        }
      })
      .catch((error) => {
        this.setState({ caseDataErr: true, isLoading: false });
        console.log('error received while deleting filters based on filterId', error);
      });
  }

  setSavedFilterAsActive(id) {
    let index = -1;
    const newFilters = this.state.savedFilters.map((filter) => {
      index++;
      return Object.assign({}, filter, {
        isActive: filter.filterId === id,
      });
    });
    this.setState(
      {
        savedFilters: newFilters,
        isOpenSavedFilterDropdown: false,
      },
      () => {
        const filterSetToUse = this.state.savedFilters.find(
          (set) => set.isActive,
        );
        this.applySavedFilterSet(filterSetToUse);
      },
    );
  }

  applySavedFilterSet(filterSetToUse) {
    let availFilters = []
    const newActiveFiltersStr = filterSetToUse.filterParams;
    const newActiveFilters = formatActiveFilters(filterSetToUse.activeFilters);
    const newActiveFiltersValues = mapActiveFilters(newActiveFiltersStr, newActiveFilters);

    // setting available filters while applying saved filters DE82718
    if (this.state.activeFilters !== undefined) {
      availFilters = removeFilterActionSavedFilter(this.state.availableFilters, this.state.activeFilters, filterSetToUse.filterParams)
      this.setState({
        availableFilters: availFilters
      })
    }

    let dynamicFilters = newActiveFilters.map((filter) => {
      if (filter.elementTypeName === 'DYNAMIC_MULTISELECT' || filter.elementTypeName === 'GROUP_SEARCH' || filter.elementTypeName === 'DROPDOWN') {
        return {
          filterValues: this.state[filter.elementId],
          ...filter
        }
      } else {
        return filter;
      }
    });
    newActiveFiltersValues.map((filterValue) => {
      if (filterValue.elementType == 'GROUP_SEARCH' && filterValue.v1 && `${filterValue.id}` !== 'corpregion') {
        filterValue.v1 = filterValue.v1.includes(",") ? filterValue.v1.split(',') : [filterValue.v1];
        let dynamicFilterIndex = dynamicFilters.findIndex(dynamicFilter => dynamicFilter.elementId == filterValue.id);
        if (dynamicFilterIndex != -1) {
          dynamicFilters[dynamicFilterIndex].filterValues.map(groupFilterValue => {
            if (filterValue.id == "cq_reason_code" && filterValue.v1[0]) {
              if (filterValue.v1.filter((item) => item.endsWith(groupFilterValue.cardBrandCode)).length == groupFilterValue.items.length) {
                groupFilterValue.selected = true;
              }
            }
            groupFilterValue.items.map(groupFilterVal => {
              if (filterValue.id == "cq_reason_code" && filterValue.v1[0] && filterValue.v1[0].includes('-') && !groupFilterVal.id.includes('-')) {
                let value = groupFilterVal.id + "-" + groupFilterVal.groupId
                groupFilterVal.selected = filterValue.v1.find((e) => e == value) ? true : false
              } else if (filterValue.v1.findIndex(v1Val => v1Val == groupFilterVal.id) == -1) {
                groupFilterVal.selected = false;
              } else {
                groupFilterVal.selected = true;
              }
            })

          })
        }
      } else if (filterValue.elementType == 'GROUP_SEARCH' && filterValue.v1 && `${filterValue.id}` === 'corpregion') {
        filterValue.v1 = filterValue.v1.includes(",") ? filterValue.v1.split(',') : [filterValue.v1];
        let dynamicFilterIndex = dynamicFilters.findIndex(dynamicFilter => dynamicFilter.elementId == filterValue.id);
        if (dynamicFilterIndex != -1) {
          dynamicFilters[dynamicFilterIndex].filterValues.map(groupFilterValue => {
            groupFilterValue.items.map(groupFilterVal => {
              for (let index = 0; index < filterValue.value.length; index++) {
                let region = ''
                let corp = ''
                region = JSON.parse(JSON.stringify(filterValue.value[index]))["regionCode"]
                corp = JSON.parse(JSON.stringify(filterValue.value[index]))["corp"]
                if (region == groupFilterVal.id && corp == groupFilterVal.groupId) {
                  groupFilterVal.selected = true
                  break;
                } else {
                  groupFilterVal.selected = false
                }
              }
            })
          })
        }
      }
    });


    this.setState({
      formattedFilters: dynamicFilters,
    })

    this.setState({
      activeFiltersValues: newActiveFiltersValues,
      activeFilters: newActiveFilters,
    }, () => {
      const body = document.querySelector('body');
      const e = document.createEvent('MouseEvents');
      e.initEvent('mousedown', true, true);
      body.dispatchEvent(e);
    });
    this.setState(
      {
        isVisible: true,
      },
    );
  }

  closeSaveFilterFailBanner() {
    this.setState({
      saveFilterFail: false,
    });
  }

  handleSelectionBaseQueue = (selectedItem) => {
    let customQueueId = selectedItem.id;
    let regionCode = this.state.selectedBaseQueueItem?.queueGroupCode;
    let acquirerAccessCode = this.state.acquirerAccessCode;
    this.props.history.push(`/base-queue-landing?region=${regionCode}&acquirerAccessCode=${acquirerAccessCode}&selectedBaseQueueItem=${selectedItem.text}&subQueueSelection=${null}&customQueueId=${customQueueId}`);
    this.setState(() => {
      this.setState({
        clearSearchTermValue: true,
        activeFiltersValues: [],
        tableName: selectedItem.text, selectedBaseQueueItem: selectedItem, selectedSubQueueItem: { text: 'Select Queue', value: "" },
        selectedBaseQueueItemFromUrl: null,
        regionCode: selectedItem.queueGroupCode
      }, () => {
        this.getSubQueueGroupList();
        this.selectQueue(selectedItem.id);
        this.getRegionCodeHeaderData();
      })
    });
  }

  handleSelectionSubQueue = (selectedItem) => {
    let baseQueuelabel = getUrlSearchParamValue(this.props.location.search, 'selectedBaseQueueItem');
    let customQueueId = selectedItem.id;
    let regionCode = this.state.selectedBaseQueueItem?.queueGroupCode;
    let acquirerAccessCode = this.state.acquirerAccessCode;
    this.props.history.push(`/sub-queue-landing-page?region=${regionCode}&acquirerAccessCode=${acquirerAccessCode}&selectedBaseQueueItem=${baseQueuelabel}&subQueueSelection=${selectedItem.text}&customQueueId=${customQueueId}`);
  }

  formatObject = (item) => {
    return {
      focus: false,
      id: item.customQueueId,
      value: item.subCategoryCode,
      text: item.baseQueueLabel,
      actionCategoryCode: item.actionCategoryCode,
      queueGroupCode: item.queueGroupCode,
    }
  }

  getBaseQueueGroupList = () => {
    let acquirerAccessList = this.state.acquirerAccessList
    let baseQueue = [];
    getBaseQueueGroupList(acquirerAccessList).then((apiResponse) => {
      let alreadySelected = apiResponse.data.filter((item) => item?.baseQueueLabel == this.state.selectedBaseQueueItem.text)[0];
      let firstItem = this.formatObject(this.state.selectedBaseQueueItemFromUrl && alreadySelected ? alreadySelected : apiResponse.data[0]);
      apiResponse.data.map((item,) => { baseQueue.push(this.formatObject(item)) })
      this.setState({
        dropDownBaseQueues: baseQueue,
        selectedBaseQueueItem: firstItem
      }, () => {
        this.getSubQueueGroupList()
        this.getRegionCodeHeaderData()
      })
    }).catch((error) => {
      console.log('error received while fetching data columns based on queue page', error);
    });
  }

  getSubQueueGroupList = () => {
    let selectedItem = this.state.selectedBaseQueueItem;
    let subQueues = [];
    if (!selectedItem?.value) {
      this.setState({ isSubQueAvailable: false })
    }
    if (selectedItem?.value) {
      this.setState({ isSubQueAvailable: true })
      getSubQueueGroupList(this.state.acquirerAccessList, selectedItem.value)
        .then(apiResponse => {
          apiResponse.data.forEach(item => {
            if (item.queueVisibilityInd) {
              subQueues.push(
                {
                  focus: false,
                  id: item.customQueueId,
                  value: item.queueCategoryCode,
                  text: item.queueLabel,
                  actionCategoryCode: item.actionCategoryCode,
                  queueGroupCode: item.queueGroupCode,
                }
              )
            }
          })
          this.setState({ dropDownSubQueues: subQueues })
        })
        .catch((error) => {
          if (!selectedItem.value) {
            this.setState({ isSubQueAvailable: false })
          }
          this.setState({ dropDownSubQueues: [] })
          console.log('error received while fetching data columns based on queue page', error);
        });
    }
  }

  formatResponseCommon = (response, elementId) => {
    let formattedData = this.getFormattedResponse(response, elementId);
    this.setState({
      [elementId]: formattedData,
    }, () => {
      this.getMultiSelectFilterValues();
    })
  }

  render() {
    window.document.title = this.state.selectedBaseQueueItem.text ? `${this.state.selectedBaseQueueItem.text} Queue` : 'Queue';
    let totalCases = []
    const queueListData = totalCases && totalCases.sort(sort_by('queueName', false, function (a) { return a.toUpperCase() }));

    const queueDataConfig = this.state.queueMetaData;
    const userId = getUrlSearchParamValue(this.props.location.search, 'userid');
    const isChecked = this.state.selectedRows.length > 0 ? true : false;
    const filterdRecords = this.state.caseData.filter(dataRow => !this.state.casesToHide.includes(dataRow.caseStageId));
    const filterPaneTriggerClasses = classnames('filter-pane-trigger', {
      'is-disabled': false,
    });
    let report = Object.assign({}, this.state.queueMetaData);
    report.dataColumns = Object.assign([], this.state.dataColumns);
    const acquirerAccessCode = this.state.acquirerAccessCode;
    if (this.props.user !== undefined && this.props.user.parsedPermissions.queue.viewCasesInQueue && this.state.statusErrorCode !== 403) {
      return (
        <section>
          {this.state.setSize == true &&
            this.checkSize()
          }
          <FloatingPanel
            count={this.state.selectedRows.length}
            text={this.state.dragOvertText}
          />
          <div className={this.props.isSearchActive ? 'main-content--header reports-container--header secondary-header' : "main-content--header reports-container--header"} style={{ zIndex: 3 }}>

            <div className="flex-left">
              <h1>{this.state.queueMetaData.headerName}</h1>
              <div className="maindiv">
                <div className="dropdown-view1">
                  <DropDownList
                    dropDownList={this.state.dropDownBaseQueues}
                    selectedItemText={this.state.selectedBaseQueueItem.text}
                    selectDropdownItem={this.handleSelectionBaseQueue}
                    extraStyle={{ left: 5, width: 230 }}
                    // wrapperButtonStyle={{ backgroundColor: '#E5F4FF' }}
                    callingComponent={"BaseQueueLanding"}
                  />
                </div>
                <div className="slash">
                  <svg width="15" height="28" viewBox="0 0 15 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {<line x1="13.8637" y1="0.807103" x2="0.44731" y2="27.6399" stroke={COLORS.oneGp.smoke} />}
                  </svg>
                </div>
                <div className="dropdown-view2">
                  <DropDownList
                    dropDownList={this.state.dropDownSubQueues}
                    selectedItemText={this.state.selectedSubQueueItem.text}
                    selectDropdownItem={this.handleSelectionSubQueue}
                    extraStyle={{ left: 5, width: 230 }}
                    // wrapperButtonStyle={{ backgroundColor: '#E5F4FF' }}
                    callingComponent={"BaseQueueLanding"}
                  />
                </div>
                {
                  <div className="getnext">
                    <button className="getnext-button" disabled={(!this.props.user.parsedPermissions.queue.getNextCaseInQueue || this.state.selectedSubQueueItem.text == 'Select Queue') ? true : false}>
                      <div className="getnext-text" > Get Next  <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.87483 5.32478L1.45058 9.68142C1.27406 9.85794 0.988621 9.85794 0.812102 9.68142L0.545445 9.41477C0.368926 9.23825 0.368926 8.95281 0.545445 8.77629L4.38756 5.00554L0.549201 1.23479C0.372681 1.05827 0.372681 0.772831 0.549201 0.596312L0.815858 0.329655C0.992377 0.153136 1.27781 0.153136 1.45433 0.329655L5.87858 4.6863C6.05135 4.86282 6.05135 5.14826 5.87483 5.32478Z" fill="currentColor" />
                      </svg>
                      </div>
                    </button>
                  </div>
                }

              </div>
            </div>
            {this.state.userPermission !== undefined && this.state.userPermission.case.masterPermission && <div className="flex-right" style={{ paddingRight: 13 }}>
              <div className="gd-report-runner__actions">
                <div className="gd-report-runner__actions-filters">
                  <a data-tip data-for="filtering" data-offset="{'right': 320}">
                    <GDActiveFiltersDropdown
                      activeFilters={this.state.activeFiltersValues}
                      dateFormat={this.state.dateFormat}
                      deactivateFilter={this.deactivateFilter}
                      dropdownToggled={this.state.dropdownToggled}
                      filterDefinitions={this.state.activeFilters}
                      toggleDropdown={this.toggleDropdown}
                      translations={getTranslations()}
                      showDynamicFilter={true}
                    />
                  </a>
                </div>
                {this.state.activeFiltersValues.length > 0 && (
                  <div className="gd-report-runner__actions-clear" style={{ minWidth: 59 }}>
                    <LinkInlineButton action={this.clearAllFilters}>
                      Clear All
                    </LinkInlineButton>
                    <span>&nbsp;|&nbsp;</span>
                  </div>
                )}
                <div className="gd-report-runner__actions-save">
                  <LinkInlineButton
                    action={this.toggleSavedFilter}
                    disabled={this.props.isProvidingSupport}
                  >
                    Save
                  </LinkInlineButton>
                  {this.state.saveFilterToggled &&
                    <GDNewFilterDropdown
                      toggleDropdown={this.toggleSavedFilter}
                      onChange={this.onChange}
                      saveFilterName={this.saveFilterName}
                      translations={getTranslations()}
                      value={this.state.filterName}
                    />
                  }
                </div>
              </div>
              <div className="gd-filters-dropdown__wrapper gd-report-runner__icon-popup-wrapper">
                <OptionBoxPopup
                  icon={StarIcon}
                  id="Transaction Search_OptionBoxPopup"
                  triggerText=""
                  showHelpText={getTranslations().savedFilters}
                >
                  <GDSavedFiltersDropdown
                    noSavedFilters={this.state.noSavedFilters}
                    onChange={this.updateSearchField}
                    removeSavedFilter={this.removeSavedFilter}
                    savedFilters={this.state.savedFilters}
                    searchTerm={this.state.currentSearchTerm}
                    setSavedFilterAsActive={this.setSavedFilterAsActive}
                    translations={getTranslations()}
                  />
                </OptionBoxPopup>
              </div>
              <div
                role="button"
                tabIndex={0}
                id="Settled Batches_filter_btn"
                className={filterPaneTriggerClasses}
                onClick={this.toggleFilterPane}
                aria-expanded={this.state.isVisible}
              >
                <span className="gd-report-runner__filter-toggle">Filter</span>
              </div>
            </div>}
          </div>

          <div className="main-content--wrapper" style={{ width: '100%' }}>
            <div className={this.props.isSearchActive ? '' : 'gd-filter-pane__wrapper'}>
              <FilterPane
                applyFilters={this.applyFilters}
                closeFilterPane={this.closeFilterPane}
                currentValues={this.state.activeFiltersValues}
                dateFormat={this.state.dateFormat}
                filterList={this.state.formattedFilters}
                isVisible={this.state.isVisible}
                translations={getTranslations()}
                reportName="Received Disputes_filterPane"
                extraClass="some-class"
                resetScrollPos={this.resetScrollPos}
                showDynamicFilter={true}
                activeFilters={this.state.activeFilters}
                availableFilters={this.state.availableFilters}
                updateColumnsInfo={this.updateColumnsInfo}
                updateIsIndeterminate={this.updateIsIndeterminate}
                listHeight="auto"
                clearAllFilters={this.clearAllFilters}
                clearSearchTermValue={this.state.clearSearchTermValue}
              />

            </div>
            {this.state.caseDataErr && !this.state.isLoading && (
              <div
                className="queue-mgmt-empty-state"
              >
                <EmptyState
                  translations={{
                    emptyStateHeading: 'This queue is empty',
                    emptyStateDescription: 'Please try again later.'
                  }}
                />
              </div>
            )
            }
            {this.state.isRequiredFilter &&
            <ImagePortal>
              <ResponseBanner
                titleStyle={{ color: 'light-green' }}
                descriptionStyle={{ color: 'grey' }}
                valueStyle={{ color: 'black' }}
                title="Validation Error"
                description="Atleast one field is required for search"
                type="danger"
                onClose={this.closeBanner}
                cancelButtonText="DISMISS"
                primaryButtonText="OKAY, DO SOMETHING TO FIX IT"
                primaryButtonAction={this.closeBanner}
              />
              </ImagePortal>
            }

            {(this.state.isLoading || totalCases === undefined) && <div className="ball-sync-loader loader" style={{ backgroundColor: 'white' }}><BVLoader20 /></div>}
            <div className="queue-mngmnt-content--wrapper">
              {this.state.saveFilterFail && <div>
                <ImagePortal>
                <ResponseBanner
                  titleStyle={{ color: 'light-green' }}
                  descriptionStyle={{ color: 'grey' }}
                  valueStyle={{ color: 'black' }}
                  title="Error Occured"
                  description="Filter name already present. Please enter unique filter name"
                  type="danger"
                  onClose={this.closeSaveFilterFailBanner}
                  cancelButtonText="DISMISS"
                  primaryButtonActionValue=""
                  primaryButtonText="OKAY, DO SOMETHING TO FIX IT"
                  primaryButtonAction={this.closeSaveFilterFailBanner}
                />
                </ImagePortal>
              </div>}

              {queueDataConfig.displayType == 'gdTable' && !this.state.isLoading && totalCases && !this.state.caseDataErr && <div style={{ width: '100%' }} className="queue-mgmt-landing-content" id="BaseQueueLanding" ref={((ref) => (this.gdTable = ref))}>
                <GDTable
                  isNewQueueLanding={true}
                  isAgGrid={true}
                  isRefreshed={this.state.isRefreshed}
                  className="queueLandingTable"
                  report={report}
                  tableName={this.state.tableName}
                  data={filterdRecords}
                  dateFormat={this.state.dateFormat}
                  totalPages={this.state.totalPages}
                  totalRecords={this.state.totalRecords}
                  recordsCountText={{ showingRecords: 'Showing records', preposition: 'of' }}
                  currentPage={this.state.currentPage}
                  recordsShown={this.state.recordsShown}
                  sort={this.state.sortArr}
                  handleSort={this.handleSort}
                  pageHandler={this.pageHandler}
                  translations={getTranslations()}
                  filterText={this.state.filterText}
                  onRowClick={this.onRowClick}
                  isPagable={queueDataConfig.isPagable}
                  onSearchChange={this.onSearchChange}
                  isNextPage={this.state.isNextPage}
                  exporting={this.state.exporting}
                  exportAction={this.exportAction}
                  filterExportIsVisible={this.state.filterExportIsVisible}
                  toggleFileExport={this.toggleFileExport}
                  actionButtonText="Actions"
                  rowActionClick={this.rowActionClick}
                  isLoading={this.state.isLoadingComplete}
                  saveCurrentlyVisibleColumns={this.saveCurrentlyVisibleColumns}
                  addIconsToGDTableHeadersList={addIconsToGDTableHeadersList}
                  titleRequired={queueDataConfig.titleRequired}
                  timeBoxData={this.state.timeBoxData}
                  refreshTimeFeed={this.refreshTimeFeed}
                  isCheckboxOnRowRequired={queueDataConfig.isCheckboxOnRowRequired}
                  recordCountRequired={queueDataConfig.recordCountRequired}
                  showCaseCountDisplay
                  isFetchingData={false}
                  headerCountDataColumn={userId ? getAnalystHeaderCountDataColumns() : getRegionHeaderCountDataColumns()}
                  headerCountData={this.state.headerCountData}
                  onCheckboxClick={this.onCheckboxClick}
                  selectedRows={this.state.selectedRows}
                  bookMarkedRows={this.state.bookMarkedRows}
                  dragOvertText={this.state.dragOvertText}
                  openBoxDropDownStyle={{
                    width: 150,
                    marginLeft: -53,
                    fontSize: 'initial',
                  }}
                  onBookMarked={this.onBookMarked}
                  agLoader={this.state.agLoader}
                  userPermissions={this.state.userPermission}
                  exportFileName={this.state.tableName}
                />

              </div>}

              {this.state.userPermission !== undefined && this.state.userPermission.case.canAssignCase && totalCases && this.state.currentGroupAnalysts && !this.state.isLoading && !this.state.caseDataErr && <div className='analyst-search-content--wrapper'>
                <AnalystSearch
                  currentGroupAnalysts={this.state.currentGroupAnalysts}
                  totalBulkCases={this.state.totalBulkCases}
                  totalCases={this.state.totalRecordsUpdated === -1 ? this.state.totalRecords : this.state.totalRecordsUpdated}
                  setTotalBulkCases={this.setTotalBulkCases}
                  bulkAssignClick={this.bulkAssignClick}
                  resetCaseCount={this.state.resetCaseCount}
                  onAssignClick={this.onAssignClick}
                  returnToText={this.state.tableName}
                  translations={getTranslations()}
                  analystDrawerMetaData={analystDrawerMetaData()}
                  promptText='Please select at least one analyst to assign cases to.'
                  isChecked={isChecked}
                />
              </div>}
            </div>
          </div>
        </section >
      );
    } else {
      return (
        <div className="queue-mgmt-empty-state">
          <EmptyState
            translations={{
              emptyStateHeading: 'You do not have permission to view this queue',
              emptyStateDescription: 'Please contact support team for further assistance.'
            }}
          />
        </div>);
    }
  }
}

BaseQueueLanding.propTypes = {
  dataColumns: PropTypes.array.isRequired,
  setNotification: PropTypes.func.isRequired,
  fetchDataColumnsCustomQueue: PropTypes.func.isRequired,
  closeNotification: PropTypes.func.isRequired,
  setCords: PropTypes.func.isRequired,
  resetCords: PropTypes.func.isRequired,
  dragOvertText: PropTypes.string,
};

const mapStateToProps = (state) => ({
  dataColumns: state.dataColumns?.columns,
  isSearchActive: state.appSearch.isSearchActive,
  user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDataColumnsCustomQueue: (pageId, search, customQueueId) => dispatch(fetchDataColumnsCustomQueue(pageId, search, customQueueId)),
    setNotification: (banner) => dispatch(dangerNotificationBanner(banner)),
    closeNotification: () => dispatch(closeNotificationBanner()),
    setCords: (cordsData) => dispatch(setCords(cordsData)),
    resetCords: () => dispatch(resetCords()),
    setSearchOpenFlag: (isSearchActive) => {
      dispatch(setSearchOpenFlag(isSearchActive));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BaseQueueLanding);